import { Grid, styled, Typography } from "@mui/material";
import { api, types } from "api";
import { GroupList } from "components/GroupList/GroupList";
import { InfoSnackBar } from "components/InfoSnackBar";
import { StyledButton } from "components/StyledButton";
import { ACTIVITIES_FETCH_ERR } from "messages";
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { getPath as getRoutePath, routes } from "routes";

const PREFIX = "TrackDashboardPage";

const classes = {
	groups: `${PREFIX}-groups`,
	groupList: `${PREFIX}-grouplist`,
	title: `${PREFIX}-title`,
	button: `${PREFIX}-button`,
	root: `${PREFIX}-root`,
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Root = styled("div")(({ theme }) => ({
	[`&.${classes.root}`]: {
		padding: 20,
	},

	[`& .${classes.button}`]: {
		marginTop: 15,
		marginRight: 5,
		float: "right",
	},

	[`& .${classes.title}`]: {
		marginTop: 5,
		marginBottom: 15,
		float: "left",
	},

	[`& .${classes.groupList}`]: {
		maxHeight: 200,
		padding: 5,
		overflowY: "auto",
		overflowX: "hidden",
		float: "left",
	},
}));

export const Groups = (): JSX.Element => {
	// new code here
	const componentMounted = useRef(true);
	const history = useHistory();
	const [groups, setGroups] = useState<types.Group[]>([]);
	const [err, setErr] = useState(false);

	// Open group management page
	const getPath = (groupId: string): string =>
		getRoutePath(routes._.trackAndReport._.trackGroup, { groupId });

	useEffect(() => {
		api
			.getGroups()
			.then((res) => {
				if (res.status !== 200) {
					setErr(true);
					return;
				}

				if (componentMounted.current) {
					setGroups(res.data || []);
				}
			})
			.catch(() => {
				setErr(true);
			});
		return () => {
			componentMounted.current = false;
		};
	}, []);

	return (
		<Root className={classes.root}>
			<Grid item xs={12}>
				<Grid container spacing={1}>
					<Grid item xs={12}>
						<Typography className={classes.title} variant="h4">
							Groups
						</Typography>
						<StyledButton
							variant="contained"
							color="primary"
							className={classes.button}
							onClick={() => {
								history.push(routes._.groups._.create.path);
							}}
							data-testid="create-group-btn"
						>
							ADD GROUP
						</StyledButton>
					</Grid>
					<Grid item xs={12} className={classes.groupList}>
						{groups.length === 0 ? (
							<Typography variant="h5" className={classes.title}>
								No groups
							</Typography>
						) : (
							<GroupList groups={groups} getPath={getPath} />
						)}
					</Grid>
				</Grid>
			</Grid>
			<InfoSnackBar
				isOpen={err}
				onClose={() => setErr(false)}
				message={ACTIVITIES_FETCH_ERR}
				severity="error"
			/>
		</Root>
	);
};
